export const permSales = [
    { name: "Automatic_Insert", label: "الإدخال (أوتماتيك)", visible: true },
    { name: "ShowQtyScreen", label: "اخفاء شاشة عرض الكميات", visible: false },
    {
        name: "UpdateSalePrice",
        label: "allow-edit-sale-price",
        visible: true,
    },
    {
        name: "sale_no_less_than_purch",
        label: "عدم السماح بسعر البيع اقل من سعر الشراء",
        visible: true,
    },
    {
        name: "sale_no_less_than_minPrice",
        label: "عدم السماح بسعر البيع اقل من السعر الأدنى",
        visible: true,
    },
    {
        name: "UpdateSaleDate",
        label: "allow-edit-sale-invoice-date",
        visible: true,
    },
    {
        name: "SaleInMinus",
        label: "allow-sale-without-stock-quantity",
        visible: true,
    },
    {
        name: "saleVatUpdate",
        label: "allow-edit-tax-on-sale",
        visible: true,
    },
    {
        name: "allow_salePrice_zero",
        label: "السماح بالبيع بصفر كزيادة او هدية",
        visible: true,
    },
    {
        name: "allow_return_Without_bill",
        label: "السماح بالارجاع بدون رقم فاتورة",
        visible: true,
    },
    {
        name: "allow_replace_Without_bill",
        label: "allow-replace-without-invoice",
        visible: true,
    },
    {
        name: "inv_post_unlock",
        label: "السماح بتعديل او حذف فاتورة بعد الترحيل",
        visible: false,
    },
    {
        // this field for users table
        name: "register_customer_no_account",
        label: "allow-customer-without-account",
        visible: true,
    },
    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true
    },
    {
        name: "PrintAfter_Save",
        label: "print-invoice-after-save",
        visible: true,
    },
    {
        name: "Purch_out_goods",
        label: "print-goods-exit-permit",
        visible: true,
    },
    {
        name: "NoRepeatItem",
        label: "الفاء تجميع الاصناف",
        visible: true,
    },
    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
    {
        name: "Cust_SalePrice",
        label: "اعتماد اخر سعر بيع للعميل لكل صنف",
        visible: true,
    },
    {
        name: "ShowBtnCar",
        label: "show-car-specifications",
        visible: true,
    },
    {
        name: "return_same_invoice_date",
        label: "ارجاع الفاتورة بنفس تاريخ فاتورة البيع",
        visible: true,
    },
    {
        name: "hide_item_data",
        label: "اخفاء زر اضافة الصنف",
        visible: true,
    },
    {
        name: "hide_item_info",
        label: "اخفاء معلومات الصنف",
        visible: true,
    },
    {
        name: "Show_units",
        label: "عرض الوحدات الفرعيه في المبيعات",
        visible: true,
    }
    // { name: "allow_discount", label: "allow-discount", visible: true },
];

export const permPurchase = [
    { name: "Automatic_Insert", label: "الإدخال (أوتماتيك)", visible: true },
    {
        name: "UpdatePurchDate",
        label: "allow-edit-purchase-invoice-date",
        visible: true,
    },
    {
        name: "UpdatePurchPrice",
        label: "allow-edit-purchase-price",
        visible: true,
    },
    {
        name: "purchVatUpdate",
        label: "السماح بتعديل الضريبه عند الشراء",
        visible: true,
    },
    {
        name: "use_price_without_vat",
        label: "استخدام السعر لا يشمل الضريبة في فاتورة الشراء",
        visible: true,
    },
    {
        name: "Purch_than_Less_Purch_Item",
        label: "السماح بالشراء بسعر اقل من  سعر الشراء في بيانات الاصناف",
        visible: true,
    },
    {
        name: "SaleInMinus",
        label: "allow-purchase-return-without-stock-quantity",
        visible: true,
    },
    {
        name: "Cust_PurchPrice",
        label: "اعتماد اخر سعر شراء للمورد لكل صنف",
        visible: false,
    },
    {
        name: "Hide_Purch_Bill_Price",
        label: "اخفاء سعر البيع",
        visible: true,
    },
    {
        name: "Purch_out_goods",
        label: "print-goods-exit-permit-purchase-return",
        visible: true,
    },

    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true
    },
    {
        name: "IS_Delete",
        label: "allow-delete-invoice-after-posting",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "allow-edit-invoice-after-posting",
        visible: true,
    },
    {
        name: "NoRepeatItem",
        label: "الفاء تجميع الاصناف",
        visible: true,
    },
    {
        name: "Cust_SalePrice",
        label: "اعتماد اخر سعر شراء للمورد لكل صنف",
        visible: true,
    },
    {
        name: "return_same_invoice_date",
        label: "ارجاع الفاتورة بنفس تاريخ فاتورة الشراء",
        visible: true,
    },
    {
        name: "allow_return_Without_bill",
        label: "السماح بالارجاع بدون رقم فاتورة",
        visible: true,
    },
    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
];

export const permPos = [
    {
        name: "SalePointOnly",
        label: "enable-pos-screen-for-user",
        visible: true,
    },
    {
        name: "used_Nsale_screen",
        label: "use-sales-screen",
        visible: true,
    },
    {
        name: "used_Rsale_screen",
        label: "use-return-screen",
        visible: true,
    },
    {
        name: "used_switch_screen",
        label: "use-replace-screen",
        visible: false,
    },
    {
        name: "used_Items_screen",
        label: "use-item-entry-screen",
        visible: true,
    },
    {
        name: "used_Group_screen",
        label: "use-groups-screen",
        visible: true,
    },
    {
        name: "used_Bcode_screen",
        label: "إستخدام طباعة الباركود",
        visible: false,
    },
    {
        name: "used_Jarde_screen",
        label: "use-item-inventory-screen",
        visible: true,
    },
    {
        name: "used_jrans_screen",
        label: "استخدام جرد حركة الصنف تفصيلي",
        visible: true,
    },
    {
        name: "used_Dialy_screen",
        label: "إستخدام تقرير  الحركة اليومية",
        visible: true,
    },
    {
        name: "used_Point_screen",
        label: "reset-pos-statistics-display",
        visible: false,
    },
    {
        name: "used_Treas_screen",
        label: "use-cashbox-movement-report",
        visible: true,
    },
    {
        name: "used_Accnt_screen",
        label: "use-account-statement-screen",
        visible: true,
    },
    {
        name: "used_SSarf_screen",
        label: "use-payment-voucher-screen",
        visible: true,
    },
    {
        name: "used_itmove_screen",
        label: "use-item-movement-report-screen",
        visible: true,
    },
    {
        name: "used_Sqabd_screen",
        label: "use-receipt-voucher-screen",
        visible: true,
    },
    {
        name: "used_purch_screen",
        label: "use-purchases-screen",
        visible: true,
    },
    {
        name: "used_Rpurch_screen",
        label: "use-purchase-return-screen",
        visible: true,
    },
    {
        name: "notShowSales",
        label: "hide-sales-show-invoice-count",
        visible: true,
    },
    {
        name: "disable_customer",
        label: "تعطيل التعامل مع اضافة العملاء(عميل نقدي فقط)",
        visible: true,
    },
    {
        name: "pos_dashboard_zero",
        label: "reset-pos-statistics-display",
        visible: true,
    },
    {
        name: "pos_dashboard_zero",
        label: "reset-pos-statistics-display",
        visible: true,
    },
    {
        name: "used_twreed_makhzni_screen",
        label: "use-stock-supply-screen",
        visible: true,
    },
    {
        name: "used_sarfe_mkhzni_screen",
        label: "use-stock-issue-screen",
        visible: true,
    },
    {
        name: "used_estlam_mkhzni_screen",
        label: "use-stock-receipt-screen",
        visible: true,
    },
    {
        name: "used_tasweay_mkhzni_screen",
        label: "use-stock-settlement-screen",
        visible: true,
    },
    { name: "", label: "allow-discount", visible: false },
];

export const permShifts = [
    {
        name: "used_shifts_trans",
        label: "استخدام نظام الورديات اجباري ",
        visible: true,
    },
    {
        name: "used_shifts_transOpen",
        label: "allow-open-shifts",
        visible: true,
    },
    {
        name: "used_shifts_transClose",
        label: "السماح بغلق الورديات",
        visible: true,
    },
    {
        name: "show_only_shiftcash",
        label: "اظهار فقط مبلغ النقدي المستلم عند اغلاق الورديات",
        visible: true,
    },

];

export const permBasic = [
    { name: "HidePurchPrice", label: "hide-purchase-price" },
    { name: "NoRepeatItem", label: "prevent-item-name-duplicate" },
    {
        name: "show_ItemExpired_Alert",
        label: "عدم عرض التنبيهات للاصناف عند الدخول",
    },
    {
        name: "update_price_first_stock",
        label: "تحديث سعر الشراء والبيع عند ادخال رصيد اول المدة",
    },
    {
        name: "update_price_pursh_bill",
        label: "تحديث سعر الشراء والبيع عند ادخال فاتورة المشتريات",
    },
    {
        name: "update_price_currencies",
        label: "تحديث سعر البيع فقط عند ادخال فاتورة المبيعات ",
    },
    {
        name: "is_saleprice_less_purch",
        label: "عدم السماح بتسجيل سعر البيع اقل من سعر الشراء ",
    },
    {
        name: "show_unit_on_bills",
        label: "اظهار الوحدات الفرعية للصنف في الفواتير",
    },
    { name: "costWithVat", label: "price-includes-tax" },
    {
        name: "show_price_on_bills",
        label: "اظهار الاسعار المختلفة للصنف في الفواتير",
    },
    { name: "usePriceBeforVat", label: "use-price-before-tax" },
    { name: "hide_item_balance", label: "اخفاء رصيد الاصناف" },
    {
        name: "disable_type_sale_price",
        label: "تعطيل التحكم في السعر (تجزئه, موزع, جملة)",
    },
];

export const permQutions = [
    { name: "Automatic_Insert", label: "الإدخال (أوتماتيك)", visible: true },
    { name: "ShowQtyScreen", label: "اخفاء شاشة عرض الكميات", visible: false },
    {
        name: "UpdateSalePrice",
        label: "allow-edit-quotation-price",
        visible: true,
    },
    {
        name: "sale_no_less_than_purch",
        label: "عدم السماح بسعر البيع اقل من سعر الشراء",
        visible: true,
    },
    {
        name: "sale_no_less_than_minPrice",
        label: "عدم السماح بسعر البيع اقل من السعر الأدنى",
        visible: true,
    },
    {
        name: "UpdateSaleDate",
        label: "allow-edit-quotation-date",
        visible: true,
    },
    {
        name: "SaleInMinus",
        label: "allow-quotation-without-stock-quantity",
        visible: true,
    },
    {
        name: "saleVatUpdate",
        label: "allow-edit-quotation-tax",
        visible: true,
    },
    {
        name: "allow_salePrice_zero",
        label: "allow-zero-sale-price",
        visible: true,
    },
    {
        name: "allow_return_Without_bill",
        label: "السماح بالارجاع بدون رقم فاتورة",
        visible: false,
    },
    {
        name: "allow_replace_Without_bill",
        label: "allow-replace-without-invoice",
        visible: false,
    },
    {
        name: "IS_Delete",
        label: "allow-delete-quotation-after-posting",
        visible: true,
    },
    {
        name: "IS_Update",
        label: "allow-edit-quotation-after-posting",
        visible: true,
    },
    {
        name: "register_customer_no_account",
        label: "allow-customer-without-account",
        visible: false,
    },
    {
        name: "allow_discount",
        label: "allow-discount",
        visible: true
    },
    {
        name: "PrintAfter_Save",
        label: "print-invoice-after-save",
        visible: true,
    },
    {
        name: "NoRepeatItem",
        label: "الفاء تجميع الاصناف",
        visible: true,
    },

    {
        name: "use_barcode_reader",
        label: "use-barcode-reader",
        visible: true,
    },
];
export const permOrder = [
    { name: "Automatic_Insert", label: "الإدخال (أوتماتيك)", visible: true },
  
    {
      name: "UpdatePurchDate",
      label: "السماح بتعديل تاريخ امر الشراء",
      visible: true,
    },
    {
      name: "UpdatePurchPrice",
      label: "allow-edit-purchase-price",
      visible: true,
    },
    {
      name: "purchVatUpdate",
      label: "السماح بتعديل الضريبه عند تسجيل امر الشراء",
      visible: true,
    },
    {
      name: "IS_Delete",
      label: "السماح بحذف امر الشراء بعد الترحيل",
      visible: true,
    },
    {
      name: "IS_Update",
      label: "السماح بتعديل امر الشراء  بعد الترحيل",
      visible: true,
    },
    {
      name: "use_price_without_vat",
      label: "استخدام السعر لا يشمل الضريبة في امر الشراء",
      visible: true,
    },
    {
      name: "Purch_than_Less_Purch_Item",
      label: "السماح بتسجيل سعر اقل من  سعر الشراء في بيانات الاصناف",
      visible: true,
    },
  
    {
      name: "Cust_PurchPrice",
      label: "اعتماد اخر سعر شراء للمورد لكل صنف",
      visible: false,
    },
    {
      name: "Hide_Purch_Bill_Price",
      label: "اخفاء سعر البيع",
      visible: true,
    },
    {
      name: "Purch_out_goods",
      label: "print-goods-exit-permit-purchase-return",
      visible: false,
    },
   
    { 
      name: "allow_discount", 
      label: "allow-discount", 
      visible: true 
    },
    {
      name: "inv_post_unlock",
      label: "السماح بتعديل او حذف فاتورة بعد الترحيل",
      visible: false,
    },
    {
      name: "NoRepeatItem",
      label: "الفاء تجميع الاصناف",
      visible: true,
    },
    {
      name: "use_barcode_reader",
      label: "use-barcode-reader",
      visible: true,
    },
  ];

export const permSafes = [
    { name: "Automatic_Insert", label: "الإدخال (أوتماتيك)", visible: true },
  
    {
      name: "UpdatePurchDate",
      label: "السماح بتعديل تاريخ  مخزون اول مدة",
      visible: true,
    },
    {
      name: "UpdatePurchPrice",
      label: "السماح بتعديل السعر في مخزون اول مدة ",
      visible: true,
    },
    {
      name: "purchVatUpdate",
      label: "السماح بتعديل الضريبه",
      visible: true,
    },
    {
      name: "IS_Delete",
      label: "السماح بحذف  مخزون اول مدة بعد الادخال",
      visible: true,
    },
    {
      name: "IS_Update",
      label: "السماح بتصحيح المخزون بعد الادخال",
      visible: true,
    },
    {
      name: "use_price_without_vat",
      label: "استخدام السعر لا يشمل الضريبة في امر الشراء",
      visible: false,
    },
    {
      name: "Purch_than_Less_Purch_Item",
      label: "السماح بتسجيل سعر اقل من  سعر الشراء في بيانات الاصناف",
      visible: false,
    },
  
    {
      name: "Cust_PurchPrice",
      label: "اعتماد اخر سعر شراء للمورد لكل صنف",
      visible: false,
    },
    {
      name: "Hide_Purch_Bill_Price",
      label: "اخفاء سعر البيع",
      visible: false,
    },
    {
      name: "Purch_out_goods",
      label: "print-goods-exit-permit-purchase-return",
      visible: false,
    },
   
    { 
      name: "allow_discount", 
      label: "allow-discount", 
      visible: true ,
    },
    {
      name: "inv_post_unlock",
      label: "السماح بتعديل او حذف فاتورة بعد الترحيل",
      visible: false,
    },
    {
      name: "NoRepeatItem",
      label: "الفاء تجميع الاصناف",
      visible: true,
    },
    {
      name: "use_barcode_reader",
      label: "use-barcode-reader",
      visible: true,
    },
  ];

  export const permOtherSafes=(id) => [
  
    {
      name: "UpdatePurchDate",
      label: "السماح بتعديل تاريخ",
      visible: true,
    },{
        name: "SaleInMinus",
        label:id==2? "السماح بالصرف بدون كمية بالمحزون": "السماح بالتحويل بدول كمية بالمخزون",
        visible:[2,3].includes(id)? true:false,
    },
    {
      name: "UpdatePurchPrice",
      label: "السماح بتعديل السعر",
      visible: true,
    },
    {
      name: "IS_Delete",
      label: "السماح بحذف   بعد الادخال",
      visible: true,
    },
    {
      name: "IS_Update",
      label: "السماح بتصحيح المخزون بعد الادخال",
      visible: true,
    },

    {
      name: "inv_post_unlock",
      label: "السماح بتعديل او حذف  الترحيل",
      visible: false,
    },
  ];


  export  const permOtherSales = [
    ,
    {
        name: "cancel_payed_network",
        label: "الغاء خاصية الدفع(الشبكة)",
        visible: true,
    },
    {
        name: "cancel_payed_bank",
        label: "الغاء خاصية الدفع (تحويل بنكي)",
        visible: true,
    }, {
        name: "cancel_bill_agel",
        label: "الغاء خاصية الدفع (الاجل)",
        visible: true,
    },
    ,{
        name: "cancel_payed_emp",
        label: "الغاء خاصية الدفع (الموظف)",
        visible: true,
    },
    {
        name: "Re_Discount",
        label: "خصم مسترد (عدم استقطاع مبلغ الخصم عند احتساب الضريبة)",
        visible: true,
    },
    {
        name: "Re_Discount_agel",
        label: "تقييد الخصم المسترد اجل على العميل عند عمل فاتورة",
        visible: true,
    },
    {
        name: "btnDisCode",
        label: "use Discount Code",
        visible: true,
    },
];

export  const permOthers = [
    {
        name: "is_tab3_sub",
        label: "tobacco-tax-enabled",
        visible: true,
    },
    {
        name: "use_lock_date",
        label: "تفعيل اقفال الفترات الضريبية",
        visible: true,
    },
];

export const permOtherAccount =[
    {
      name: "UpdateSaleDate",
      label: "السماح بتعديل تاريخ المستند",
      visible: true,
    },
    {
      name: "IS_Delete",
      label: "السماح بحذف المستند بعد الحفظ",
      visible: true,
    },
    {
      name: "IS_Update",
      label: "السماح بتعديل المستند بعد الحفظ",
      visible: true,
    },
    {
      name: "show_cust_balance",
      label: "عرض رصيد الحساب عند الطباعه",
      visible: true,
    },
  ];

export const select_Types = [
    { Form_id: 40002, id: 1,  name: "المبيعات" },
    { Form_id: 40001, id: 3,  name: "المشتريات" },
    { Form_id: 10004, id: 4, name: "البيانات الأساسية"},
    { Form_id: 40014, id: 5, name: "عرض السعر"},
    { Form_id: 40025, id: 6,  name: "أمر الشراء"},
    { Form_id: 40005, id: 7, name: "المخازن"},
    { Form_id: 50001, id: 8,  name: "الحسابات"},
    { Form_id: 1000,  id: 9, name: "الحسابات الوسيطة"},
    { Form_id: 40005, id: 10,  name: "اعدادات اخرى" }, 
  ];

  
  


